import { useState } from "react";
import {
    DISCARD_CHANGES_MODAL_BODY_TEXT,
    DISCARD_CHANGES_TEXT,
    MODAL_CANCEL_TEXT,
} from "../../utils/constants";
import YuJaDialog from "../standardization/YuJaDialog";

export default function DiscardChangesConfirmationModal({
    show,
    setShow,
    handleSubmit,
    title = DISCARD_CHANGES_TEXT,
    bodyText = DISCARD_CHANGES_MODAL_BODY_TEXT,
    confirmText = DISCARD_CHANGES_TEXT,
}) {
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <YuJaDialog
            open={show}
            setOpen={setShow}
            title={title}
            closeText={MODAL_CANCEL_TEXT}
            submitText={confirmText}
            isSubmitBtnDisabled={isSubmitting}
            fitContent
            onSubmit={async () => {
                setIsSubmitting(true);
                await handleSubmit();
                setIsSubmitting(false);
            }}
        >
            {bodyText}
        </YuJaDialog>
    );
}
